import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function eSimTagsManagementTableReducer(state = initialState.eSimTagsManagementTable, action) {
    switch (action.type) {
    case types.LOAD_SIM_TAG_MANAGEMENT_TABLE_SUCCESS:
        return action.eSimTagsManagementTable;
    default:
        return state;
    }
}